<template lang="pug">
transition(name="navigate", appear, mode="out-in")
  slot
</template>

<script>
export default {
  name: "transition-navigate",
};
</script>

<style lang="scss">
.navigate-enter-active,
.navigate-leave-active {
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-property: opacity;
}
.navigate-enter-from {
  opacity: 0;
  position: absolute;
}
.navigate-leave-to {
  opacity: 0;
  z-index: 1;
}
</style>